import { UseMutateAsyncFunction, useMutation, useQueryClient } from "@tanstack/react-query"
import { useNavigate } from "react-router"
import { useAxios } from "../../contexts/AxiosContext"
import { appRoutes } from "../../routes/appRoutes"
import { removeExperimentCache } from "../../utils/queryInvalidation"

type DeleteExperimentProps = {
  experimentId: string
}

type DeleteExperimentResponse = {
  message: string
}

type UseDeleteExperimentType = UseMutateAsyncFunction<DeleteExperimentResponse, unknown, DeleteExperimentProps, unknown>

const useDeleteExperiment = (): UseDeleteExperimentType => {

  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { axiosApiInstance } = useAxios()

  const { mutateAsync: deleteExperimentMutation } = useMutation({
    mutationFn: async (params: DeleteExperimentProps) => {
      const response = await axiosApiInstance.delete<DeleteExperimentResponse>(`/experiment/experiment/${params.experimentId}`)
      return response.data
    },
    onSuccess: async (_response: DeleteExperimentResponse, params: DeleteExperimentProps) => {
      navigate(appRoutes.experiments.root, { replace: true, flushSync: true })
      await removeExperimentCache(queryClient, params.experimentId)
    },
  })

  return deleteExperimentMutation
}

export default useDeleteExperiment
